module.exports = __webpack_public_path__ + "img/successcheck.2be45081.svg";